import EmptyRow from "../../../general/table/emptyRow";
import TableLoader from "../../../general/table/tableLoader";
import LoginHistoryTableRowItem from "./loginHistoryTable_rowItem";

const LoginHistoryTable = ({
  dataList,
  dataListTitles,
  isRequesting
}) => {

  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item, i) => {
      return <LoginHistoryTableRowItem item={item} key={i} />
    });

  return(
    <table>
      <thead>
        <tr>
          {_dataListTitles}
        </tr>
      </thead>
      <tbody>
        { isRequesting ? 
            <TableLoader colSpan={dataListTitles.length} /> : 
            _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} />
        }
      </tbody>
    </table>
  )
}

export default LoginHistoryTable;
